let sdkPromise: Promise<typeof import('microsoft-cognitiveservices-speech-sdk')> | null = null

export const loadSpeechSdk = () => {
  if (!sdkPromise) {
    sdkPromise = import('microsoft-cognitiveservices-speech-sdk')
  }
  return sdkPromise
}

export const isSpeechSdkLoaded = () => sdkPromise !== null
